import React, { useState } from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";
import { Form, Formik } from "formik";
import {
  newVendorMerchantFields,
  getFormFields,
  getFormValidations,
  getInitialFormValues,
} from "../../../../Dashboard/Views/AddNewVendor/formFields";

import "./style.css";

const formConfigArray = [...newVendorMerchantFields];
const formValidationRules = getFormValidations(formConfigArray);
const initialFormValues = getInitialFormValues(formConfigArray);

const AccessForExistingProduct = ({
  submitHandler,
  duns,
  actionInProgress,
  errMsg,
}) => {
  return (
    <Formik
      initialValues={initialFormValues}
      validationSchema={formValidationRules}
      onSubmit={(values, { setSubmitting }) => {
        setSubmitting(true);
        let dataToSubmit = {
          ...values,
          duns: duns || null,
        };
        submitHandler(dataToSubmit);
        setSubmitting(false);
      }}
      render={({ isSubmitting, isValid, dirty, resetForm }) => (
        <Form>
          <Modal.Body className="selectNewAccessType_modalBody">
            <Row style={{ marginBottom: 20 }}>
              <p style={{ fontSize: 15 }}>
                In order to access an existing vendor record, please provide
                your primary merchant contact at Macy’s Inc. They will be
                contacted and asked to approve you access request.
              </p>
            </Row>
            <Row>{getFormFields(formConfigArray).map((field) => field)}</Row>
          </Modal.Body>
          <Modal.Footer>
            <div className="accessRequest_modalFooter_container">
              <div className="requestError">{errMsg}</div>
              <Button
                className="button-primary-md"
                type="submit"
                disabled={
                  !isValid || !dirty || isSubmitting || actionInProgress
                }
              >
                REQUEST ACCESS
              </Button>
            </div>
          </Modal.Footer>
        </Form>
      )}
    />
  );
};

export default AccessForExistingProduct;
